module.exports = __webpack_public_path__ + "img/TransporNet.de80fb0d.png";